export default __webpack_public_path__ + "static/media/LebenswerkBrandrelaxo.565814fc.png";